/** Motifs KO — liste fixe (alignée sur backend/constants/koMotifs.js). */
export const KO_MOTIFS = [
  'CONSOMMATION MAUVAISE VÉRIFICATION',
  'TITRE DE PROPRIÉTÉ MAUVAISE VÉRIFICATION',
  'ÂGE MODE DE CHAUFFAGE',
  'SURFACE CHAUFFÉE',
  'TYPE DE CONTRAT',
  'REVENU MAUVAISE VÉRIFICATION',
  'MAUVAISE VÉRIFICATION 20M²',
  'SURFACE JARDIN',
  'ÂGE CLIENT VÉRIFICATION NON EFFECTUÉE',
  'INTÉRÊT',
  'TRAITEMENT',
  'ZONE MAUVAISE VÉRIFICATION',
  'ÂGE DES PANNEAUX EXISTANTS',
  "TAUX D'ENDETTEMENT NON VÉRIFIÉ",
  'CLIENT NON SÉRIEUX',
  'DÉMÉNAGEMENT',
  'VERROUILLAGE',
  'KO ACCORD',
  'COORDONNÉES NON VÉRIFIÉES',
  'VÉRIFICATION REVENU',
  "DOMAINE D'ACTIVITÉ",
  'AUTRE',
];

export default KO_MOTIFS;
